import { mapActions, mapGetters, mapState } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import widgetEmptyState from '@/components/generics/widget-empty-state/widget-empty-state';
import applySortOrder from '@/components/pinning/pinboard-sort';
import pinboardWidgetItem from '@/components/pinning/pinboard-widget-item/pinboard-widget-item.vue';
import pinboardWidgetSkeleton from '@/components/pinning/pinboard-widget-skeleton/pinboard-widget-skeleton.vue';
import log from '@/logger';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';

const WATCHLIST_SIZE = 10;

export default {
  mixins: [loaderMixin],
  components: { pinboardWidgetItem, widgetEmptyState, pinboardWidgetSkeleton },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('pinning', ['getWidgetSort']),
    ...mapState('watchlist', ['watchlist']),
    items() {
      const sort = this.getWidgetSort('watchlist');
      const results = this.watchlist.data === null ? [] : this.watchlist.data;
      const mapped = results.slice(0, WATCHLIST_SIZE).map((item) => {
        const c = this.firstContract(item);
        return Object.assign({}, item, {
          price: c ? c.changePriceAsCents : 0,
          tradeVolume: c ? c.totalSharesTradedNumber : 0,
          investmentSize: c ? c.investmentSizeAsCents : 0,
        });
      });
      return applySortOrder(mapped, sort, 'watchlist');
    },
  },
  methods: {
    ...mapActions('watchlist', ['getWatchList', 'resetWatchlist']),
    ...mapActions('popup', ['setCurrentPopup']),
    onLogin() {
      this.setCurrentPopup(MODALS.LOGIN);
    },
    itemLink(item, contractId) {
      const query = {};
      if (contractId) {
        query.contractId = contractId;
      }
      return {
        name: 'market-details',
        params: { marketId: item.marketId },
        query,
      };
    },
    firstContract(item) {
      return item.contracts && item.contracts[0] ? new Contract(item.contracts[0]) : null;
    },
    firstContractName(item) {
      const c = this.firstContract(item);
      return c ? c.contractName : '';
    },
    firstContractPrice(item) {
      const c = this.firstContract(item);
      return c ? c.lastTradePriceAsCents : 0;
    },
    firstContractChangePrice(item) {
      const c = this.firstContract(item);
      return c ? c.changePriceAsCents : 0;
    },
    firstContractLastClosePrice(item) {
      const c = this.firstContract(item);
      return c ? c.lastClosePrice : null;
    },
    firstContractHasLastTradePrice(item) {
      const c = this.firstContract(item);
      return c ? c.hasLastTradePrice : false;
    },
    firstContractId(item) {
      const c = item.contracts && item.contracts[0];
      return c ? c.contractId : null;
    },
    loadWatchlist() {
      this.loaderAdd();
      this.getWatchList()
        .catch((error) => log.error('Request failed.', error))
        .finally(() => this.loaderRemove());
    },
    initWatchlist() {
      if (this.watchlist.page !== 0) return;
      this.resetWatchlist().then(() => this.loadWatchlist());
    },
  },
  watch: {
    isLoggedIn(val) {
      if (val) this.initWatchlist();
    },
  },
  mounted() {
    if (!this.isLoggedIn) return;
    this.initWatchlist();
  },
};
